export default __webpack_public_path__ + "static/media/neuf.57daa4df.jpg";